/** Parses the upper bound of a delivery-time string into days, or null if unknown. */
export function deliveryTimeUpperBoundDays(raw: string | null | undefined): number | null {
  const text = (raw ?? "").trim().toLowerCase();
  if (!text) return null;

  let max = 0;
  const tokens = text.replace(/[–—/−]/g, " ").split(/\s+/);
  for (const token of tokens) {
    const n = Number.parseFloat(token.replace(",", "."));
    if (Number.isFinite(n) && n > max) max = n;
  }
  if (max <= 0) return null;
  if (text.includes("woche")) return max * 7;
  return max;
}

export function shouldShowDeliveryTime(raw: string | null | undefined): boolean {
  const days = deliveryTimeUpperBoundDays(raw);
  return days != null && days < 14;
}

export type PriceCutKind = "euros" | "none";

export function resolvePriceCut(
  priceCents: number,
  cut: number,
): { kind: PriceCutKind; benefitPrice: number; savings: number; percent: number } {
  if (!Number.isFinite(priceCents) || priceCents <= 0 || !Number.isFinite(cut) || cut <= 0) {
    return { kind: "none", benefitPrice: priceCents, savings: 0, percent: 0 };
  }
  const savings = Math.min(priceCents, Math.round(cut * 100));
  const benefitPrice = priceCents - savings;
  const percent = Math.round((savings * 100) / priceCents);
  return { kind: "euros", benefitPrice, savings, percent };
}

const deliveryCases: Array<[string, number | null, boolean]> = [
  ["ca. 2-4 Werktage", 4, true],
  ["8-14 Werktage", 14, false],
  ["1-3 Wochen", 21, false],
  ["ca. 10 Werktage (DE)", 10, true],
  ["", null, false],
];
for (const [input, days, visible] of deliveryCases) {
  const actualDays = deliveryTimeUpperBoundDays(input);
  const actualVisible = shouldShowDeliveryTime(input);
  if (actualDays !== days || actualVisible !== visible) {
    console.error("upsell delivery parse failed", { input, actualDays, days, actualVisible, visible });
  }
}

const euroCut = resolvePriceCut(25990, 90);
if (euroCut.kind !== "euros" || euroCut.savings !== 9000 || euroCut.benefitPrice !== 16990 || euroCut.percent !== 35) {
  console.error("upsell euro price cut failed", euroCut);
}
const mattressCut = resolvePriceCut(44990, 50);
if (mattressCut.kind !== "euros" || mattressCut.savings !== 5000 || mattressCut.benefitPrice !== 39990) {
  console.error("upsell mattress euro cut failed", mattressCut);
}
